import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import AddUserLayer from "../components/AddUser";


const AddUserPage = () => {
  return (
    <>
      
        {/* Breadcrumb */}
        <Breadcrumb title="Add User" />

        {/* AddUserLayer */}
        <AddUserLayer />
     
    </>
  );
};

export default AddUserPage;
